var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHealthScreening = function SvgHealthScreening(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.13.1-Reports---default",
    transform: "translate(-16.000000, -238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Health-screening",
    transform: "translate(8.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(8.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38187499,8.35124999 L9.519375,12.14375 C9.5785248,12.340559 9.7520732,12.4811333 9.956875,12.498125 L10,12.5 C10.1893448,12.5000173 10.3624557,12.393078 10.4471875,12.22375 L11.5,10.118125 L12.0528125,11.22375 C12.1375443,11.393078 12.3106553,11.5000173 12.5,11.5 L15.2625,11.5 C15.0781876,11.7771019 14.8800193,12.0447334 14.66875,12.301875 C14.0821875,13.016875 13.01875,14.16 10.5628125,15.8271875 C10.2238013,16.0595305 9.77682367,16.0595305 9.4378125,15.8271875 C6.98187498,14.16 5.91843747,13.016875 5.33187497,12.301875 C4.8470833,11.7108333 4.45885413,11.1102083 4.16718746,10.5 L6.99999998,10.5 C7.18833083,10.4989563 7.36009853,10.3921753 7.44437498,10.22375 L8.38187499,8.35124999 Z M16.5,10.5 C16.7761424,10.5 17,10.7238576 17,11 C17,11.2761424 16.7761424,11.5 16.5,11.5 L15.2625,11.5 C15.4759993,11.1805644 15.6665813,10.8463932 15.8328125,10.5 Z M13.02875,3.99999996 C14.923125,3.99999996 16.4803125,5.57937497 16.5,7.52031248 C16.5114109,8.55181305 16.2830104,9.57185913 15.8328125,10.5 L12.8090625,10.5 L11.9484375,8.77624999 C11.8637311,8.60688666 11.690615,8.49990897 11.50125,8.49990897 C11.311885,8.49990897 11.1387689,8.60688666 11.0540625,8.77624999 L10.1165625,10.64875 L8.97906249,6.85624998 C8.92022088,6.65981904 8.74740943,6.5192272 8.54311526,6.50158236 C8.33882109,6.48393752 8.14446286,6.592817 8.05281249,6.77624998 L6.69093748,9.49999996 L3.77906246,9.49999996 C3.58602089,8.85811058 3.49191997,8.19055258 3.49999996,7.52031248 C3.51968746,5.57937497 5.07687497,3.99999996 6.97124998,3.99999996 C8.47406249,3.99999996 9.4725,4.92218747 10,5.59374997 C10.52875,4.92312497 11.5259375,3.99999996 13.02875,3.99999996 Z M3.77906246,9.5 C3.88281047,9.84272135 4.01256221,10.1770254 4.16718746,10.5 L3.49999996,10.5 C3.22385758,10.5 2.99999996,10.2761424 2.99999996,10 C2.99999996,9.72385762 3.22385758,9.5 3.49999996,9.5 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHealthScreening, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/health-screening.36d00484.svg";
export { ForwardRef as ReactComponent };